// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mobile-impr-card[data-v-5a806cd7] {\n  width: 100%;\n  border-radius: 16px 16px 0 0;\n  border-top: 3px solid #3949ab;\n}\n.mobile-impr-section[data-v-5a806cd7] {\n  padding: 16px 16px 12px;\n}\n", ""]);
// Exports
module.exports = exports;
